import { useEffect, useState } from "react";
import { getStats, type Stats as StatsData } from "../api";
import type { T } from "../i18n";

function money(minor: number, currency: string): string {
  return `${(minor / 100).toFixed(2)} ${currency}`;
}

export function Stats({ t }: { t: T }) {
  const [data, setData] = useState<StatsData | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getStats().then(setData).catch(() => setError(t("common.error")));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) return <p className="error">{error}</p>;
  if (!data) return <p>…</p>;

  return (
    <div className="stats">
      <h3>{t("stats.tips")}</h3>
      {data.tips.length === 0 ? (
        <p className="muted">{t("common.empty")}</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>{t("tippages.currency")}</th>
              <th>{t("stats.count")}</th>
              <th>{t("stats.gross")}</th>
              <th>{t("stats.fees")}</th>
            </tr>
          </thead>
          <tbody>
            {data.tips.map((s) => (
              <tr key={s.currency}>
                <td>{s.currency}</td>
                <td>{s.count}</td>
                <td>{money(s.gross_minor, s.currency)}</td>
                <td>{money(s.fee_minor, s.currency)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <h3>{t("stats.outstanding")}</h3>
      {data.outstanding.length === 0 ? (
        <p className="muted">{t("common.empty")}</p>
      ) : (
        <ul>
          {data.outstanding.map((b) => (
            <li key={b.currency}>{money(b.amount, b.currency)}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
